import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {
  currentLanguage: string = 'fr';
  availableLanguages: string[] = ['fr', 'en'];
  
  languageNames = {
    'fr': 'Français',
    'en': 'English'
  };

  constructor(
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.currentLanguage = this.translationService.getCurrentLang();
  }

  onLanguageChange(lang: string): void {
    this.currentLanguage = lang;
    this.translationService.setLanguage(lang);
  }

  getLanguageName(code: string): string {
    return this.languageNames[code] || code;
  }
}
